export const convertRegion = (code: number): string => {
    let region: string = '';

    switch (code) {
        case 2661: 
            region = 'Санкт-Петербург';
            break;
        case 3446: 
            region = 'Ленинградская область';
            break; 
        case 3: 
            region = 'Москва';
            break;
        case 81: 
            region = 'Московская область';
            break;
        case 2843: 
            region = 'Краснодарский край';
            break;
        case 2871: 
            region = 'Нижегородская область';
            break;
        case 3230: 
            region = 'Ростовская область';
            break;
        case 3106: 
            region = 'Самарская область';
            break;
        case 2922: 
            region = 'Республика Татарстан';
            break;
        case 2900: 
            region = 'Ставропольский край';
            break;
        case 2722: 
            region = 'Республика Башкортостан';
            break;
        case 6171: 
            region = 'Свердловская область';
            break; 
        case 4417: 
            region = 'Республика Коми';
            break; 
        case 5282: 
            region = 'Челябинская область';
            break; 
        case 5368: 
            region = 'Иркутская область';
            break; 
        case 5520: 
            region = 'Пермский край';
            break; 
        case 6817: 
            region = 'Алтайский край';
            break;
        case 9579: 
            region = 'Республика Бурятия';
            break;
        case 2604: 
            region = 'Ярославская область';
            break;
        case 1010: 
            region = 'Удмуртская Республика';
            break;
        case 7793: 
            region = 'Псковская область';
            break;
        case 13919: 
            region = 'Республика Северная Осетия — Алания';
            break;
        case 2860: 
            region = 'Кемеровская область';
            break;
        case 3019: 
            region = 'Чувашская Республика';
            break;
        case 4982: 
            region = 'Республика Марий Эл';
            break;
        case 9648: 
            region = 'Кабардино-Балкарская Республика';
            break;
        case 5241: 
            region = 'Республика Мордовия';
            break;
        case 3870: 
            region = 'Красноярский край';
            break;
        case 3991: 
            region = 'Тюменская область';
            break;
        case 2359: 
            region = 'Республика Хакасия';
            break;
        case 9654: 
            region = 'Новосибирская область';
            break;
        case 2072: 
            region = 'Воронежская область';
            break;
        case 8090: 
            region = 'Республика Карелия';
            break;
        case 4007: 
            region = 'Республика Дагестан';
            break;
        case 11171: 
            region = 'Республика Саха (Якутия)';
            break;
        case 10160: 
            region = 'Забайкальский край';
            break;
        case 7873: 
            region = 'Республика Крым';
            break;
        case 6937: 
            region = 'Республика Крым';
            break;
        case 2594: 
            region = 'Кировская область';
            break;
        case 8509: 
            region = 'Республика Калмыкия';
            break;
        case 11416: 
            region = 'Республика Адыгея';
            break;
        case 11991: 
            region = 'Карачаево-Черкесская Республика';
            break;
        case 5178: 
            region = 'Республика Тыва';
            break;
        case 13913: 
            region = 'Республика Ингушетия';
            break;
        case 6309: 
            region = 'Республика Алтай';
            break;
        case 5952: 
            region = 'Белгородская область';
            break;
        case 6543: 
            region = 'Архангельская область';
            break;
        case 2880: 
            region = 'Тверская область';
            break;
        case 5993: 
            region = 'Пензенская область';
            break;
        case 2484: 
            region = 'Ханты-Мансийский автономный округ';
            break;
        case 4240: 
            region = 'Липецкая область';
            break;
        case 5789: 
            region = 'Владимирская область';
            break;
        case 14880: 
            region = 'Ямало-Ненецкий автономный округ';
            break;
        case 1491: 
            region = 'Рязанская область';
            break;
        case 2885: 
            region = 'Чеченская Республика';
            break;
        case 5794: 
            region = 'Смоленская область';
            break;
        case 2528: 
            region = 'Саратовская область';
            break;
        case 4374: 
            region = 'Вологодская область';
            break;
        case 4695: 
            region = 'Волгоградская область';
            break;
        case 2328: 
            region = 'Калужская область';
            break;
        case 5143: 
            region = 'Тульская область';
            break;
        case 2806: 
            region = 'Тамбовская область';
            break;
        case 14368: 
            region = 'Мурманская область';
            break;
        case 5736: 
            region = 'Новгородская область';
            break;
        case 7121: 
            region = 'Курская область';
            break;
        case 4086: 
            region = 'Хабаровский край';
            break;
        case 821: 
            region = 'Брянская область';
            break;
        case 10582: 
            region = 'Астраханская область';
            break;
        case 7896: 
            region = 'Калининградская область';
            break;
        case 8640: 
            region = 'Омская область';
            break;
        case 5703: 
            region = 'Курганская область';
            break;
        case 10201: 
            region = 'Томская область';
            break;
        case 4249: 
            region = 'Ульяновская область';
            break;
        case 3153: 
            region = 'Оренбургская область';
            break;
        case 4189: 
            region = 'Костромская область';
            break;
        case 2814: 
            region = 'Орловская область';
            break;
        case 13098: 
            region = 'Камчатский край';
            break;
        case 8894: 
            region = 'Ивановская область';
            break;
        case 7929: 
            region = 'Амурская область';
            break;
        case 16705: 
            region = 'Магаданская область';
            break;
        case 69: 
            region = 'Еврейская автономная область';
            break;
        case 4963: 
            region = 'Приморский край';
            break;
        case 1901: 
            region = 'Сахалинская область';
            break;
        case 61888: 
            region = 'Ненецкий автономный округ';
            break;
    }

    return region;
};


export const codeOfRegions: number[] = [
    2661,    81,  2871,  2843,     3,  3106,  2922,  2900,  2722,  6171,  3230,  4417,
    5282,  5368,  3446,  5520,  6817,  9579,  2604,  1010,  9648,  7793, 13919,  2860,
    3019,  4982,  5241,  3870,  3991,  2359,  9654,  2072,  8090,  4007, 11171, 10160,
    7873,  2594,  8509, 11416, 11991,  5178, 13913,  6309,  5952,  6543,  2880,  5993,
    2484,  4240,  5789, 14880,  1491,  2885,  5794,  2528,  4374,  4695,  2328,  5143,
    6937,  2806, 14368,  5736,  7121,  4086,   821, 10582,  7896,  8640,  5703, 10201,
    4249,  3153,  4189,  2814, 13098,  8894,  7929, 16705,    69,  4963,  1901, 61888
];